import React from "react";
import { useMultiSelectFilterContext } from "../MultiSelectFilter.context";
var MultiSelectFilterOption = function (_a) {
    var name = _a.name, value = _a.value, disabled = _a.disabled;
    var _b = useMultiSelectFilterContext(), onChange = _b.onChange, nameInput = _b.name, multiSelectModel = _b.multiSelectModel;
    var isSelected = multiSelectModel.optionIsSelected(value);
    var onChangeValue = function (e, newValue) {
        var newValues = multiSelectModel.toggleOption(newValue);
        onChange(newValues, e);
    };
    var handleKeyDownOption = function (event, newValue) {
        if (event.key === " ") {
            onChangeValue(event, newValue);
            event.preventDefault();
        }
    };
    var id = nameInput + "-" + value;
    return (React.createElement("li", { className: "ssg-multi-select-filter__option-checkbox-option", "data-name": nameInput, "data-value": value, onKeyDown: function (e) { return handleKeyDownOption(e, value); }, tabIndex: 0, "aria-disabled": disabled !== null && disabled !== void 0 ? disabled : false },
        React.createElement("div", { className: "fr-checkbox-group " + (disabled ? "fr-checkbox-group--disabled" : "") },
            React.createElement("input", { type: "checkbox", className: "fr-input", id: id, name: nameInput, value: value, checked: isSelected, onChange: function (e) { return onChangeValue(e, value); }, disabled: disabled }),
            React.createElement("label", { className: "fr-label", htmlFor: id }, name))));
};
export default MultiSelectFilterOption;
